import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchCoupons'
})
export class SearchCouponsPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      return it.coupon_code.toLowerCase().includes(searchText);
    });
  }

}
